export default {
    id: "6",
    images: "https://i.ytimg.com/vi/h-VFqwzNHgo/maxresdefault.jpg",
    type: "益智遊戲",
    name: "魔法氣泡2",
    play: "PC",
    number: "2人",
    date: "2021年2月25日",
    Make: "Compile公司 ",
    price: "690",
    link: "",
    intro: "日本人氣益智遊戲《魔法氣泡》和舉世聞名的《俄羅斯方塊》再度強強聯手、推出新作，讓各位玩家盡情炸裂氣泡、恣意消除方塊，來一場樂趣無窮的遊戲饗宴！"
}






// WEBPACK FOOTER //
// ./src/database/game6.js